import { style } from '@angular/animations';
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';



const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string, cols: any[]): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    workbook.SheetNames[0] = excelFileName;
    workbook.Sheets[excelFileName] = worksheet;
    

    

    //  const excelConfig = {    
    //   headerStyle: {
    //     fill: {fgColor: {rgb: "D3D3D3"}},
    //     font: {name: 'Arial', sz:10, bold: true},
    //     alignment: { wrapText: true, vertical: 'bottom', horizontal: 'center' }
    //   }
    // };

   
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    let i=0;
    for (let index = range.s.r; index <= range.e.c; ++index) {
      i=0;
      const address = XLSX.utils.encode_col(index) + '1';
      // const header1 = XLSX.utils.encode_cell({c: index, r: i});    
      worksheet[address].v = cols[index];

      // worksheet[header1].s =excelConfig.headerStyle;

      i++;
    }
   
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array',cellStyles: true,bookSST:true});
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const now = new Date();
    const dateTime = now.toISOString().slice(0, 19).replace(/:/g, '-');
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + dateTime + EXCEL_EXTENSION);
  }
}
